import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';

export type UserUserGroupsResponseItem = {
  groupId: string;
  groupName: string;
};

export type UserUserGroupsResponse = {
  groups: UserUserGroupsResponseItem[];
};

export default function useUserUserGroups(
  organizationId: string,
  userId: string,
  params = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-user/v1/organizations/${organizationId}/users/${userId}/groups`;
  return useQuery<UserUserGroupsResponse, ServerErrorResponse>(
    ['user_user_groups', organizationId, userId],
    async ({ signal }): Promise<UserUserGroupsResponse> => {
      try {
        const paramString = createParamString(params);
        const data: UserUserGroupsResponse = await fetcher({
          method: 'get',
          url: `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      ...options,
    }
  );
}
